module.exports = __webpack_public_path__ + "img/logo.c74e4479.png";